import React from "react";
import EstoqueEmbalagemTopo from "./topo";
import EstoqueParceiroDetalhes from "./detalhe";

/* Localização */
/*
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
*/
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';


import br from "date-fns/locale/pt-BR";
import Parceiro from "../../components/classes/Parceiro";
import Utils from "../../helper/utils";

import styles from './detail.module.css';

export default function EstoqueParceiroPage() {
  var parceiro: Parceiro = JSON.parse(
    String(localStorage.getItem("ParceiroSelecionado"))
  );

  Utils.setDocumentTitle("Estoque", parceiro.apelido.valueOf());

  return (
    <React.Fragment>
      <div className={`container ${styles.container}`}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
          <EstoqueEmbalagemTopo parceiro={parceiro} />
          <EstoqueParceiroDetalhes parceiro={parceiro} />
        </LocalizationProvider>
      </div>
    </React.Fragment>
  );
}
